import { API } from "../../constants";
import { ApiResponse } from "../../types";
import { apiSlice } from "../api-slice";
import { Tag } from "./types";

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllTagNames: build.query<string[], void>({
      query: () => `${API}/tag/allactivebyplays`,
      transformResponse: (response: ApiResponse<string[]>) => response.data,
    }),
    getAllTags: build.query<Tag[], void>({
      query: () => `${API}/tag/allactive`,
      transformResponse: (response: ApiResponse<Tag[]>) => response.data,
      providesTags: ["Tag"],
    }),
    createTag: build.mutation<ApiResponse<Tag>, { name: string; color: string; textColor: string }>({
      query: (tag) => ({ method: "POST", url: `${API}/tag`, body: tag }),
      invalidatesTags: ["Tag"],
    }),
    deleteTag: build.mutation<ApiResponse<Tag>, { id: string }>({
      query: (tag) => ({ method: "DELETE", url: `${API}/tag/${tag.id}` }),
      invalidatesTags: ["Tag"],
    }),
    editTag: build.mutation<
      ApiResponse<Tag>,
      { id: string; tag_id: string; name?: string; color?: string; textColor?: string }
    >({
      query: ({ id, tag_id, name, color, textColor }) => ({
        method: "POST",
        url: `${API}/tag`,
        body: { name, id, tag_id, color, textColor },
      }),
      invalidatesTags: ["Tag", "PlayData"],
    }),
  }),
});

export const {
  useGetAllTagNamesQuery,
  useLazyGetAllTagNamesQuery,
  useGetAllTagsQuery,
  useLazyGetAllTagsQuery,
  useCreateTagMutation,
  useDeleteTagMutation,
  useEditTagMutation,
} = extendedApiSlice;
